export default __webpack_public_path__ + "static/media/Selfcare-hover.ff5ad430.svg";